export const landingTranslations = {
  en: {
    // Nav
    navFeatures: "Features",
    navHowItWorks: "How It Works",
    navPricing: "Pricing",
    navFaq: "FAQ",
    navSignIn: "Sign in",
    navCta: "Try Free Calculator",

    // Announcement
    announce: "Built with dispatchers, for dispatchers",

    // Hero
    heroKicker: "The Load-Screening OS for US Dispatch",
    heroTitle1: "Know if a load",
    heroTitleProfit: "makes money",
    heroTitle2: "before you book it.",
    heroSubtitle:
      "Real-time profit math — trip cost, driver pay, dispatcher fee, deadhead — turned into one decision in under 3 seconds.",
    heroCta: "Try Free Calculator",
    heroCta2: "See how it works",
    heroTrust: "Trusted by carriers across all 48 states",

    // Live widget
    widgetPickCity: "PICK",
    widgetDelivery: "DELIVERY",
    widgetRate: "RATE",
    widgetMiles: "TOTAL MILES",
    widgetRpm: "REAL RPM",
    widgetNet: "NET PROFIT",
    widgetGoal: "GOAL",
    widgetProfitable: "PROFITABLE LOAD",
    widgetUnprofitable: "NOT PROFITABLE",

    // Stats
    stat1: "Loads screened",
    stat2: "Avg. decision time",
    stat3: "Avg. profit lifted per truck / week",
    stat4: "Carriers on the platform",

    // Problem
    problemKicker: "The Cost of Guessing",
    problemTitle: "One bad load erases three good ones.",
    problemBody:
      "Every dispatcher has taken a $1,100 haul that quietly bled $180 after deadhead, fuel and driver pay. Do that twice a week and it's a five-figure hole in your P&L by year end.",
    problemStat1: "$500",
    problemStat1Label: "avg. loss on a mispriced load",
    problemStat2: "$19",
    problemStat2Label: "monthly subscription",
    problemStat3: "0",
    problemStat3Label: "excuses left",

    // How
    howKicker: "How It Works",
    howTitle: "Three inputs. One decision.",
    howSubtitle:
      "Paste the offer, set your true cost, and let the calculator do the ugly math.",
    how1Title: "Load info",
    how1Body: "Pick, delivery, miles (loaded + empty), weight, commodity and rate.",
    how2Title: "True cost",
    how2Body: "Cost/mile, driver pay/mile, dispatcher fee %, minimum profit goal.",
    how3Title: "Verdict",
    how3Body: "Green PROFITABLE LOAD or red NOT PROFITABLE. Save, export, compare.",

    // Features
    featuresKicker: "Features",
    featuresTitle: "Everything a dispatch desk actually uses.",
    f1Title: "Real-time math",
    f1Body:
      "Every keystroke recomputes Real RPM, trip cost, driver pay, dispatcher fee, net profit and profit/mile.",
    f2Title: "Side-by-side compare",
    f2Body:
      "Two loads, one screen. Instantly see which one clears your minimum profit goal.",
    f3Title: "One-click PDF",
    f3Body:
      "Send drivers, brokers or accountants a branded profitability report in seconds.",
    f4Title: "English & Arabic RTL",
    f4Body:
      "Full bilingual UI — including right-to-left layout — for teams from Detroit to Dubai.",
    f5Title: "Load history",
    f5Body:
      "Every screened load is saved so you can audit dispatcher decisions and coach on margins.",
    f6Title: "Minimum profit lock",
    f6Body:
      "Set your floor once. The calculator refuses to greenlight anything below it.",

    // Compare
    compareKicker: "Load vs Load",
    compareTitle: "Stop picking with your gut. Pick with the P&L.",
    compareBody:
      "Load A pays more. Load B has less deadhead. Which one actually pays your driver? See both at once.",

    // Testimonials
    testKicker: "Operators talking",
    testTitle: "Dispatchers stopped guessing.",
    t1: "We killed three losing loads in our first week. Paid for the year in an afternoon.",
    t1Name: "Marco V.",
    t1Role: "Dispatch Manager, 22-truck fleet",
    t2: "My new dispatchers stopped taking $0.90/mile freight. The lock is the killer feature.",
    t2Name: "Jasmine R.",
    t2Role: "Owner, Regional Reefer Carrier",
    t3: "The Arabic RTL matters — half my team is in Amman. Everyone reads the same number.",
    t3Name: "Omar S.",
    t3Role: "Ops Lead, Cross-border Van Fleet",

    // Pricing
    pricingKicker: "Pricing",
    pricingTitle: "One plan. One price. Zero excuses.",
    pricingSubtitle:
      "Cancel any time. Every plan includes unlimited loads, PDF exports and bilingual support.",
    priceLabel: "/ month, per user",
    priceInclude1: "Unlimited load screenings",
    priceInclude2: "Side-by-side load comparison",
    priceInclude3: "Branded PDF exports",
    priceInclude4: "Load history & audit trail",
    priceInclude5: "English + Arabic (RTL)",
    priceInclude6: "Email support",
    pricingCta: "Start with the free calculator",
    pricingGuarantee: "$500 lost load pays for 2+ years of this",

    // FAQ
    faqKicker: "FAQ",
    faqTitle: "The questions dispatchers actually ask.",
    faq1Q: "Do I need to install anything?",
    faq1A:
      "No. Open the calculator in your browser on any device — desk, phone or truck cab tablet.",
    faq2Q: "Does it work for owner-operators?",
    faq2A:
      "Yes. Set your true cost/mile and driver pay/mile (even if you're both), and it screens loads exactly the same.",
    faq3Q: "Can I export to PDF for my accountant?",
    faq3A:
      "One click. Every saved load and every side-by-side comparison exports to a branded PDF report.",
    faq4Q: "Is there a free version?",
    faq4A:
      "Yes. The full calculator is free to use in-browser. Paid plans unlock unlimited saved history, team seats and priority support.",

    // Final CTA
    finalKicker: "Ready?",
    finalTitle: "Stop booking loads that lose money.",
    finalSubtitle:
      "Screen your next offer in the time it takes to read this sentence.",
    finalCta: "Try Free Calculator",

    // Footer
    footerRights: "All rights reserved.",
    footerBuilt: "Built for US dispatch companies and truck drivers.",
  },
  ar: {
    navFeatures: "المميزات",
    navHowItWorks: "طريقة العمل",
    navPricing: "الأسعار",
    navFaq: "الأسئلة الشائعة",
    navSignIn: "تسجيل الدخول",
    navCta: "جرّب الحاسبة مجاناً",

    announce: "مصمَّمة مع الديسباتشرز، من أجل الديسباتشرز",

    heroKicker: "نظام فحص الحمولات لمكاتب الديسباتش في أمريكا",
    heroTitle1: "اعرف إن كانت الحمولة",
    heroTitleProfit: "مربحة",
    heroTitle2: "قبل أن تحجزها.",
    heroSubtitle:
      "حسابات فورية للتكلفة، أجر السائق، عمولة الديسباتشر، والأميال الفارغة — كل ذلك يتحول إلى قرار واحد في أقل من 3 ثوانٍ.",
    heroCta: "جرّب الحاسبة مجاناً",
    heroCta2: "شاهد كيف تعمل",
    heroTrust: "موثوقة من قِبَل شركات نقل في جميع الولايات الأمريكية",

    widgetPickCity: "التحميل",
    widgetDelivery: "التسليم",
    widgetRate: "السعر",
    widgetMiles: "إجمالي الأميال",
    widgetRpm: "السعر الحقيقي/ميل",
    widgetNet: "صافي الربح",
    widgetGoal: "الهدف",
    widgetProfitable: "حمولة مربحة",
    widgetUnprofitable: "غير مربحة",

    stat1: "حمولات مفحوصة",
    stat2: "متوسط زمن القرار",
    stat3: "الربح الإضافي الأسبوعي لكل شاحنة",
    stat4: "شركات نقل على المنصة",

    problemKicker: "تكلفة التخمين",
    problemTitle: "حمولة خاسرة واحدة تمحو ثلاث حمولات ناجحة.",
    problemBody:
      "كل ديسباتشر أخذ حمولة بـ 1,100$ نزفت 180$ خسارة بسبب الأميال الفارغة والوقود وأجر السائق. اجعلها مرتين في الأسبوع، وستكون خسارتك بالآلاف نهاية السنة.",
    problemStat1: "500$",
    problemStat1Label: "متوسط خسارة الحمولة المسعّرة خطأً",
    problemStat2: "19$",
    problemStat2Label: "الاشتراك الشهري",
    problemStat3: "0",
    problemStat3Label: "أعذار متبقية",

    howKicker: "طريقة العمل",
    howTitle: "ثلاث مدخلات. قرار واحد.",
    howSubtitle:
      "الصق العرض، حدّد تكلفتك الحقيقية، ودع الحاسبة تقوم بالحسابات المعقدة.",
    how1Title: "معلومات الحمولة",
    how1Body: "التحميل، التسليم، الأميال (محملة + فارغة)، الوزن، النوع والسعر.",
    how2Title: "التكلفة الحقيقية",
    how2Body: "تكلفة/ميل، أجر السائق/ميل، نسبة عمولة الديسباتشر، الحد الأدنى للربح.",
    how3Title: "الحكم",
    how3Body: "حمولة مربحة (أخضر) أو غير مربحة (أحمر). احفظ، صدّر، قارن.",

    featuresKicker: "المميزات",
    featuresTitle: "كل ما يحتاجه مكتب الديسباتش فعلياً.",
    f1Title: "حسابات فورية",
    f1Body: "كل ضغطة مفتاح تعيد حساب السعر الحقيقي، التكلفة، أجر السائق، العمولة، الربح.",
    f2Title: "مقارنة جنباً إلى جنب",
    f2Body: "حمولتان في شاشة واحدة. اعرف فوراً أيهما يتجاوز الحد الأدنى للربح.",
    f3Title: "تصدير PDF بضغطة",
    f3Body: "أرسل تقرير ربحية احترافي للسائق أو الوسيط أو المحاسب في ثوانٍ.",
    f4Title: "إنجليزية وعربية (RTL)",
    f4Body: "واجهة كاملة ثنائية اللغة، بما في ذلك التخطيط من اليمين لليسار.",
    f5Title: "سجل الحمولات",
    f5Body: "كل حمولة مفحوصة محفوظة — تدقيق قرارات الديسباتشرز وتدريبهم على الهامش.",
    f6Title: "قفل الحد الأدنى للربح",
    f6Body: "حدد الأرضية مرة واحدة، والحاسبة ترفض الموافقة على أي حمولة تحتها.",

    compareKicker: "حمولة مقابل حمولة",
    compareTitle: "لا تختر بحدسك. اختر بالأرقام.",
    compareBody:
      "حمولة A تدفع أكثر. حمولة B لديها ديدهيد أقل. أيّهما فعلياً يدفع لسائقك؟ شاهدهما معاً.",

    testKicker: "ماذا يقول المشغّلون",
    testTitle: "الديسباتشرز توقفوا عن التخمين.",
    t1: "قتلنا ثلاث حمولات خاسرة في أول أسبوع. غطينا تكلفة السنة كاملة في ظهيرة واحدة.",
    t1Name: "ماركو ف.",
    t1Role: "مدير ديسباتش، أسطول 22 شاحنة",
    t2: "الديسباتشرز الجدد توقفوا عن أخذ حمولات بـ 0.90$/ميل. القفل هو الميزة الحاسمة.",
    t2Name: "ياسمين ر.",
    t2Role: "مالكة، شركة نقل ريفر إقليمية",
    t3: "دعم العربية RTL مهم — نصف فريقي في عمّان. الجميع يقرأ نفس الرقم.",
    t3Name: "عمر س.",
    t3Role: "قائد عمليات، أسطول عابر للحدود",

    pricingKicker: "الأسعار",
    pricingTitle: "خطة واحدة. سعر واحد. صفر أعذار.",
    pricingSubtitle: "إلغاء في أي وقت. كل خطة تشمل حمولات وتصدير PDF ودعم عربي/إنجليزي.",
    priceLabel: "/ شهرياً، لكل مستخدم",
    priceInclude1: "فحص حمولات غير محدود",
    priceInclude2: "مقارنة جنباً إلى جنب",
    priceInclude3: "تصدير PDF بعلامتك التجارية",
    priceInclude4: "سجل الحمولات والتدقيق",
    priceInclude5: "إنجليزي + عربي (RTL)",
    priceInclude6: "دعم عبر البريد الإلكتروني",
    pricingCta: "ابدأ بالحاسبة المجانية",
    pricingGuarantee: "خسارة حمولة واحدة بـ 500$ تدفع اشتراك سنتين",

    faqKicker: "الأسئلة الشائعة",
    faqTitle: "الأسئلة التي يسألها الديسباتشرز فعلاً.",
    faq1Q: "هل أحتاج لتثبيت أي شيء؟",
    faq1A: "لا. افتح الحاسبة في المتصفح على أي جهاز — كمبيوتر، جوال، أو تابلت الكابينة.",
    faq2Q: "هل تعمل مع الـ owner-operators؟",
    faq2A: "نعم. حدد تكلفتك الحقيقية وأجر السائق (حتى لو كنت الاثنين معاً) وستفحص الحمولات بنفس الطريقة.",
    faq3Q: "هل أستطيع التصدير إلى PDF للمحاسب؟",
    faq3A: "بضغطة واحدة. كل حمولة محفوظة وكل مقارنة تُصدَّر كتقرير PDF احترافي.",
    faq4Q: "هل يوجد نسخة مجانية؟",
    faq4A: "نعم. الحاسبة الكاملة مجانية في المتصفح. الخطط المدفوعة تفتح السجل غير المحدود والمقاعد الجماعية.",

    finalKicker: "جاهز؟",
    finalTitle: "توقف عن حجز الحمولات التي تخسر مالك.",
    finalSubtitle: "افحص عرضك القادم في الوقت الذي تستغرقه لقراءة هذه الجملة.",
    finalCta: "جرّب الحاسبة مجاناً",

    footerRights: "جميع الحقوق محفوظة.",
    footerBuilt: "مصمَّم لشركات الديسباتش وسائقي الشاحنات في الولايات المتحدة.",
  },
};

export const useLandingT = (lang) => (key) =>
  landingTranslations[lang]?.[key] ?? key;
